// reCAPTCHA v3 (invisible, score-based) for every public form: Form Template
// blocks (FormBlock.vue), the newsletter signup and the journal proposal
// page. The server half is App\Rules\PassesRecaptcha, which expects the
// same action. With no site key (keys not set up) nothing loads and no
// token is sent, which the server accepts.

export const RECAPTCHA_ACTION = 'form_submit';

// Google's script, loaded once per page and only when a form needs it.
export function loadRecaptcha(siteKey) {
  if (window.grecaptcha?.execute) return Promise.resolve(window.grecaptcha);
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-recaptcha]');
    const script = existing || document.createElement('script');
    script.addEventListener('load', () => window.grecaptcha.ready(() => resolve(window.grecaptcha)));
    script.addEventListener('error', reject);
    if (!existing) {
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
      script.async = true;
      script.dataset.recaptcha = '1';
      document.head.appendChild(script);
    }
  });
}

// A token for one submission, or null. A failed load sends no token; the
// server then answers with its readable "spam check failed" error instead of
// the form silently doing nothing.
export async function recaptchaToken(siteKey) {
  if (!siteKey) return null;
  try {
    const grecaptcha = await loadRecaptcha(siteKey);
    return await grecaptcha.execute(siteKey, { action: RECAPTCHA_ACTION });
  } catch {
    return null;
  }
}
